import styles from "../../styles/expenses.create.statement.modal.module.css";
import {Button} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import React from "react";

export const StaffSelection = ({staffLoading, availableStaff, handleAddStaff, handleAddAllStaff}) => (
    <>
        <div className={styles.staffSelectionContainer}>
            <div className={styles.selectionTitle}>
                Добавить дополнительных сотрудников:
            </div>
            {staffLoading ? (
                <div className={styles.loadingMessage}>
                    Загрузка списка сотрудников...
                </div>
            ) : (
                <div className={styles.staffButtonsContainer}>
                    {availableStaff.map(staff => (
                        <Button
                            key={staff.id}
                            size="small"
                            icon={<PlusOutlined/>}
                            onClick={() => handleAddStaff(staff.id)}
                            className={styles.staffButton}
                        >
                            {/* Используем fullName, который мы создали в useStaffData */}
                            {staff.fullName}
                        </Button>
                    ))}
                </div>
            )}
        </div>

        <div className={styles.buttonContainer}>
            <Button
                type="dashed"
                onClick={handleAddAllStaff}
                style={{width: '100%'}}
                icon={<PlusOutlined/>}
            >
                Добавить всех оставшихся сотрудников ({availableStaff.length})
            </Button>
        </div>
    </>
);